import moment from 'moment';
const template = {
  popupIsAllDay: function () {
    return 'All Day';
  },
  popupStateFree: function () {
    return 'Free';
  },
  popupStateBusy: function () {
    return 'Busy';
  },
  titlePlaceholder: function () {
    return 'Subject';
  },
  locationPlaceholder: function () {
    return 'Location';
  },
  startDatePlaceholder: function () {
    return 'Start date';
  },
  endDatePlaceholder: function () {
    return 'End date';
  },
  popupSave: function () {
    return 'Save';
  },
  popupUpdate: function () {
    return 'Update';
  },
  popupDetailDate: function (isAllDay, start, end) {
    var isSameDate = moment(start).isSame(end);
    var endFormat = (isSameDate ? '' : 'DD.MM.YYYY') + 'hh:mm';

    if (isAllDay) {
      return moment(start).format('DD.MM.YYYY') + (isSameDate ? '' : ' - ' + moment(end).format('DD.MM.YYYY'));
    }

    return moment(start).format('DD.MM.YYYY hh:mm') + ' - ' + moment(end).format(endFormat);
  },
  popupDetailLocation: function (schedule) {
    return 'Location : ' + schedule.location;
  },
  popupDetailUser: function (schedule) {
    return 'User : ' + (schedule.attendees || []).join(', ');
  },
  popupDetailState: function (schedule) {
    return 'State : ' + schedule.state || 'Busy';
  },
  popupDetailRepeat: function (schedule) {
    return 'Repeat : ' + schedule.recurrenceRule;
  },
  popupDetailBody: function (schedule) {
    return 'Body : ' + schedule.body;
  },
  popupEdit: function () {
    return 'Edit';
  },
  popupDelete: function () {
    return null;
  },
  timegridDisplayPrimaryTime: ({
    hour,
    minutes
  }) => {
    const hours = hour < 10 ? `0${hour}` : hour;
    const minutess = minutes === 0 ? '00' : minutes;
    return `${hours}:${minutess}`;
  },
  time: function (schedule) {
    const id = schedule.title === 'client' ? 'clientToLocal' : 'expertToLocal';
    const result = `${schedule.title} 
      <span class=${id}> 
        ${moment(schedule.start.getTime()).format('HH:mm')} 
        - ${moment(schedule.end.getTime()).format('HH:mm')} 
      </span>`;
    return result;
  }
};
export default template;